<template>
  <div>
    <div v-if="data" class="columns has-text-centered">
      <!-- Column Title -->
      <div class="column is-one-third">
        <div>
          <div
            class="heading is-size-6 border"
            :class="`bg${range(data.p)}`"
            :style="{
              padding: this.var === 'CClimad' ? '12px 0' : '6px 0',
              marginTop: '15px',
              minHeight: '38px',
            }"
          >
            <div v-if="this.var !== 'CClimad'" class="columns is-mobile is-vcentered">
              <!-- Icon -->
              <div class="column is-2">
                <i
                  class="material-icons has-text-white icon-dash"
                  v-tooltip.top="'Ver más'"
                  v-on:click="switchSubGroups()"
                  v-if="items"
                  style="cursor: pointer;"
                >
                  {{ active ? "remove_circle_outline" : "add_circle_outline" }}
                </i>
              </div>
              <!-- Text -->
              <div class="column titleC">
                {{ title }} {{ data ? data.p : 0 | number1(1) }}%
              </div>
              <div
                v-tooltip.top="{
                  content: createBodyTooltipInter(),
                  classes: 'contentTooltipInter',
                }"
                class="column is-2"
                v-on:click="getDataInter(data)"
              >
                <i
                  class="material-icons has-text-white icon-dash"
                  style="cursor: pointer;"
                >
                  info
                </i>
              </div>
              <div v-if="this.var === 'CClimad'" class="column is-2"></div>
            </div>
            <div
              v-if="this.var === 'CClimad'"
              class="is-flex is-justify-between"
              style="margin: 0 20px 0 20px;"
            >
              <span class="titleC"> {{ title }}</span>
              <span>{{ data ? data.p : 0 | number1(1) }}%</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Columns Graph -->
      <div class="column">
        <div
          style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
        >
          <div
            class="has-text-centered content-nodata-graph"
            :class="`bg${range(data.p)}`"
            v-if="!validateDataGraph(data)"
          >
            <span class="is-flex"
              ><i class="material-icons">insert_chart</i>&nbsp;No hay
              suficientes datos</span
            >
          </div>
          <y-graph
            v-if="validateDataGraph(data)"
            :datagraph="createDataGraphHorizontalBar(data, title)"
            :cambio="change"
            style="height: 65px !important;"
          ></y-graph>
        </div>
      </div>
    </div>
    <div
      v-if="dataTarget && Object.keys(dataTarget).length"
      class="columns has-text-centered content-historic"
    >
      <!-- Column Title -->
      <div class="column is-one-third">
        <div>
          <div
            class="heading is-size-6 border"
            :class="`bg${range(dataTarget.p)}`"
            style="padding: 5px; margin-top: 15px; min-height: 32px;"
          >
            <div v-if="this.var !== 'CClimad'" class="columns is-mobile is-vcentered">
              <!-- Icon -->
              <div class="column is-2"></div>
              <!-- Text -->
              <div class="column titleC">
                {{ title }}{{ targetYear ? ` (${targetYear})` : "" }}
                {{ dataTarget ? dataTarget.p : 0 | number1(1) }}%
              </div>
              <div
                v-tooltip.top="{
                  content: createBodyTooltipInter(),
                  classes: 'contentTooltipInter',
                }"
                class="column is-2"
                v-on:click="getDataInter(dataTarget)"
              >
                <i
                  class="material-icons has-text-white icon-dash"
                  style="cursor: pointer;"
                >
                  info
                </i>
              </div>
              <div v-if="this.var === 'CClimad'" class="column is-2"></div>
            </div>
            <div
              v-if="this.var === 'CClimad'"
              class="is-flex is-justify-between"
              style="margin: 0 20px 0 20px;"
            >
              <span class="titleC">
                {{ title }}{{ targetYear ? ` (${targetYear})` : "" }}
              </span>
              <span>{{ dataTarget ? dataTarget.p : 0 | number1(1) }}%</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Columns Graph -->
      <div class="column">
        <div
          style="padding-top: 0.6% !important; margin: 0px !important; width: 100%"
        >
          <div
            class="has-text-centered content-nodata-graph"
            :class="`bg${range(dataTarget.p)}`"
            v-if="!validateDataGraph(dataTarget)"
          >
            <span class="is-flex"
              ><i class="material-icons">insert_chart</i>&nbsp;No hay
              suficientes datos</span
            >
          </div>
          <y-graph
            v-if="validateDataGraph(dataTarget)"
            :datagraph="createDataGraphHorizontalBar(dataTarget, title)"
            :cambio="change"
            style="height: 65px !important;"
          ></y-graph>
        </div>
      </div>
    </div>

    <!-- Only Title -->
    <div v-if="!data && title">
      <div
        style="margin-bottom: 15px; margin-top: 15px;"
        class="is-flex is-justify-center"
      >
        <hr class="has-text-dark" style="width: 20%" />
        <h1
          class="title is-size-4"
          style="margin-top: 10px; margin-right: 15px; margin-left: 15px"
        >
          {{ title }}
        </h1>
        <hr class="has-text-dark" style="width: 20%" />
      </div>
    </div>
  </div>
</template>
<script>
import { CLIMA_COLORS } from "../climaColors";
import json from "../interpretaciones.json";
import yGraph from "@/components/dashboard/GraphFrs.vue";
export default {
  data() {
    return {
      interpretations: json,
      horizontalBar: {
        type: "horizontalBar",
        options: {
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
          hover: {
            animationDuration: 0,
          },
          tooltips: {
            enabled: false,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  display: false,
                },
                scaleLabel: {
                  display: false,
                },
                gridLines: {
                  display: false,
                },
                stacked: true,
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  display: false,
                  beginAtZero: true,
                  max: 100,
                },
                stacked: true,
              },
            ],
          },
          legend: {
            position: "top",
            display: false,
          },
          animate: {},
          pointLabelFontFamily: "Quadon Extra Bold",
          scaleFontFamily: "Quadon Extra Bold",
          responsive: true,
          // El contenedor tiene alto fijo; sin esto Chart.js deriva el ancho
          // del alto y las barras no se ajustan al ancho de la pantalla.
          maintainAspectRatio: false,
          resizeDelay: 0,
          plugins: {
            datalabels: {
              formatter: function(value, context) {
                return `${value}%`;
              },
              textAlign: "start",
            },
          },
        },
        data: {
          labels: ["Data 1"],
          datasets: [
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
            {
              label: "Sin datos",
              data: [0],
              backgroundColor: ["#d4d5d3"],
            },
          ],
        },
      },
      rangeColors: [
        CLIMA_COLORS[1],
        CLIMA_COLORS[2],
        CLIMA_COLORS[3],
        CLIMA_COLORS[4],
        CLIMA_COLORS[5],
        CLIMA_COLORS[6],
      ],
      colors: {
        "Muy alto": "#045a8d",
        Alto: "#0570b0",
        Medio: "#3690c0",
        Bajo: "#74a9cf",
        "Muy bajo": "#a6bddb",
      },
    };
  },
  props: {
    group: String,
    var: String,
    title: String,
    change: Number,
    data: Object,
    dataTarget: {
      type: Object || null,
      default() {
        return null;
      },
    },
    active: {
      type: Boolean,
      default() {
        return false;
      },
    },
    items: {
      type: Boolean,
      default() {
        return null;
      },
    },
    targetYear: {
      type: [String, Number],
      default: "",
    },
    ranges: Function,
  },
  mounted() {
    // console.log(this.dataTarget);
    // console.log(this.active);
    // console.log(this.data, this.title);
  },
  methods: {
    createDataGraphHorizontalBar(data, label) {
      try {
        if (data && label) {
          const dataHorizontalBar = {
            type: "horizontalBar",
            options: {
              layout: {
                padding: {
                  left: 0,
                  right: 0,
                  top: 12,
                  bottom: 0,
                },
              },
              hover: {
                animationDuration: 0,
              },
              tooltips: {
                enabled: false,
                custom: function(tooltipModel) {
                  // Tooltip Element
                  let tooltipEl = document.getElementById("chartjs-tooltip");
                  // Create element on first render
                  if (!tooltipEl) {
                    tooltipEl = document.createElement("div");
                    tooltipEl.id = "chartjs-tooltip";
                    tooltipEl.innerHTML = "<table></table>";
                    tooltipEl.style.backgroundColor = "rgba(0,0,0,0.9)";
                    tooltipEl.style.borderRadius = "5%";
                    document.body.appendChild(tooltipEl);
                  }

                  // Hide if no tooltip
                  if (tooltipModel.opacity === 0) {
                    tooltipEl.style.opacity = 0;
                    return;
                  }

                  // Set caret Position
                  tooltipEl.classList.remove("above", "below", "no-transform");
                  if (tooltipModel.yAlign) {
                    tooltipEl.classList.add(tooltipModel.yAlign);
                  } else {
                    tooltipEl.classList.add("no-transform");
                  }

                  function getBody(bodyItem) {
                    return bodyItem.lines;
                  }

                  // Set Text
                  if (tooltipModel.body) {
                    let titleLines = tooltipModel.title || [];
                    let bodyLines = tooltipModel.body.map(getBody);

                    let innerHtml = "<thead>";

                    titleLines.forEach(function(title) {
                      innerHtml +=
                        '<tr><th style="color: white;">' + title + "</th></tr>";
                    });
                    innerHtml += "</thead><tbody>";

                    bodyLines.forEach(function(body, i) {
                      let colors = tooltipModel.labelColors[i];
                      let style = "background:" + colors.backgroundColor;
                      style += "; border-color:" + colors.borderColor;
                      style += "; border-width: 2px";
                      let span =
                        '<span style="width: 10px; height: 10px; ' +
                        style +
                        '"></span>';
                      innerHtml +=
                        '<tr><td style="color: white; display: flex; gap: 5px; align-items: center;">' +
                        span +
                        body +
                        "%" +
                        "</td></tr>";
                    });
                    innerHtml += "</tbody>";

                    let tableRoot = tooltipEl.querySelector("table");
                    tableRoot.innerHTML = innerHtml;
                  }

                  // `this` will be the overall tooltip
                  let position = this._chart.canvas.getBoundingClientRect();

                  // Display, position, and set styles for font
                  tooltipEl.style.opacity = 1;
                  tooltipEl.style.position = "absolute";
                  tooltipEl.style.left =
                    position.left +
                    window.pageXOffset +
                    tooltipModel.caretX +
                    "px";
                  tooltipEl.style.top =
                    position.top +
                    window.pageYOffset +
                    tooltipModel.caretY +
                    "px";
                  tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                  tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
                  tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                  tooltipEl.style.padding =
                    tooltipModel.yPadding +
                    "px " +
                    tooltipModel.xPadding +
                    "px";
                  tooltipEl.style.pointerEvents = "none";
                },
              },
              scales: {
                xAxes: [
                  {
                    ticks: {
                      display: false,
                      beginAtZero: true,
                      max: 100,
                    },
                    scaleLabel: {
                      display: false,
                    },
                    gridLines: {
                      display: false,
                    },
                    stacked: true,
                  },
                ],
                yAxes: [
                  {
                    gridLines: {
                      display: false,
                    },
                    ticks: {
                      display: false,
                    },
                    stacked: true,
                  },
                ],
              },
              legend: {
                position: "top",
                display: false,
              },
              animate: {},
              pointLabelFontFamily: "Quadon Extra Bold",
              scaleFontFamily: "Quadon Extra Bold",
              responsive: true,
              // El contenedor tiene alto fijo; sin esto Chart.js deriva el
              // ancho del alto y las barras no se ajustan al ancho de pantalla.
              maintainAspectRatio: false,
              resizeDelay: 0,
              plugins: {
                datalabels: {
                  formatter: function(value, context) {
                    // En pantallas angostas ocultamos los segmentos muy
                    // pequeños para que las etiquetas no se amontonen.
                    const minToShow =
                      typeof window !== "undefined" && window.innerWidth <= 768
                        ? 8
                        : 3;
                    if (value >= minToShow) return `${value}%`;
                    return "";
                  },
                  anchor: "center",
                  align: "center",
                  textAlign: "center",
                  color: "#ffff",
                },
              },
            },
            data: {
              labels: ["Data 1"],
              datasets: [
                {
                  label: "Dataset 1",
                  data: [28],
                  backgroundColor: ["#f4cdcd"],
                },
                {
                  label: "Dataset 2",
                  data: [45.7],
                  backgroundColor: ["#facca5"],
                },
                {
                  label: "Dataset 3",
                  data: [65.9],
                  backgroundColor: ["#fff2cc"],
                },
                {
                  label: "Dataset 4",
                  data: [72.4],
                  backgroundColor: [CLIMA_COLORS[2]],
                },
                {
                  label: "Dataset 5",
                  data: [32],
                  backgroundColor: ["#c8d9f7"],
                },
              ],
            },
          };

          const sumData = data.n1;
          let datasets = [];

          // Función que ordena la data a un formato fijo
          const orderData = (p, d) => {
            const postion = (df) => {
              datasets[df] = d;
            };
            switch (p) {
              case "Muy bajo":
                postion(0);
                break;
              case "Bajo":
                postion(1);
                break;
              case "Medio":
                postion(2);
                break;
              case "Alto":
                postion(3);
                break;
              case "Muy alto":
                postion(4);
                break;
              default:
                break;
            }
          };

          Object.entries(data).map(([k, x]) => {
            const d = {
              label: "Dataset",
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
            };
            const porcentage = this.calculatePorcentage(x, sumData);
            const color = this.colors[k];
            d.data.push(porcentage);
            d.label = k;
            d.backgroundColor.push(color);
            d.borderColor.push(color);

            orderData(d.label, d);
          });

          dataHorizontalBar.data.labels = [label];
          dataHorizontalBar.data.datasets = datasets.filter((x) => {
            if (x) return true;
          });

          return dataHorizontalBar;
        }
        return this.horizontalBar;
      } catch (error) {
        console.log(error);
      }
    },
    validateDataGraph(data) {
      return !!data;
    },
    createBodyTooltipInter() {
      const group = this.group;
      const sub = this.var;
      if (!group) {
        return `<div><h2 class='has-text-centered is-size-5 has-text-weight-bold'>${this.interpretations[sub].title}</h2><br><p>${this.interpretations[sub]["def"]}</p><br></div>`;
      } else if (group) {
        return `<div><h2 class='has-text-centered is-size-5 has-text-weight-bold'>${this.interpretations[group].dimensiones[sub].title}</h2><br><p>${this.interpretations[group].dimensiones[sub]["def"]}</p>
          <br><span class='is-size-7 has-text-weight-bold'>Clic para ver más.</span></div>`;
      } else {
        return `<div><h2 class='has-text-centered is-size-5 has-text-weight-bold'>Error en los datos</h2><br><p>Revisa porfavor que los datos estes subidos correctamente, posiblemente el nombre de la columna de este dato no se ingreso correctamente.</p><br><span class="has-text-weight-bold">Erro en el dato</span></div>`;
      }
    },
    getDataInter(data) {
      if (this.group) {
        const allData = {
          ...data,
          group: this.group,
          subGroup: this.var,
          title: this.title,
          active: this.active,
          color: this.rangeColors[this.range(data.p)],
          type: 1,
        };
        this.$emit("openMenuInter", allData);
      }
    },
    switchSubGroups() {
      this.$emit("switchSubGroups", this.var);
    },
    calculatePorcentage(v, sum) {
      return ((v * 100) / sum).toFixed(1);
    },
    range(p) {
      return this.ranges(p);
    },
  },
  components: {
    yGraph,
  },
};
</script>
<style lang="scss" scoped>
.titleC {
  margin: auto;
  text-overflow: ellipsis !important;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: inline-block;
  text-transform: initial;
}

.onlyTitle {
  border: solid 1px rgba(65, 64, 64, 0.99);
  text-align: center;
}

.content-historic {
  margin-top: -45px;
  opacity: 0.5;
}
.content-historic .titleC {
  font-size: 14px !important;
}
.content-historic .material-icons {
  font-size: 18px !important;
}

.contentTooltipInter {
  max-width: 20% !important;
  min-width: 10% !important;
}

.tooltip {
  z-index: 55 !important;
}

.bg1 {
  background-color: var(--clima-1) !important;
  // border: solid 1px #4b9e52;
  color: white !important;
}

.bg2 {
  background-color: var(--clima-2) !important;
  // border: solid 1px rgb(91, 185, 99);
  color: rgba(65, 64, 64, 0.91);
}

.bg3 {
  background-color: var(--clima-3) !important;
  // border: solid 1px #B8C97E;
  color: rgba(65, 64, 64, 0.91);
}

.bg4 {
  background-color: var(--clima-4) !important;
  // border: solid 1px #f8d166;
  color: rgba(65, 64, 64, 0.91);
}

.bg5 {
  background-color: var(--clima-5) !important;
  // border: solid 1px #f4aa79;
  color: rgba(65, 64, 64, 0.91);
}

.bg6 {
  background-color: var(--clima-6) !important;
  // border: solid 1px #f97a7a;
  color: rgba(65, 64, 64, 0.91);
}

.bg0 {
  background-color: rgba(175, 174, 174, 0.8);
  // border: solid 1px rgba(117, 117, 117, 0.8);
  color: rgba(65, 64, 64, 0.91);
}

// Color icons
.bg1 .icon-dash {
  background-color: var(--clima-1-soft) !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg2 .icon-dash {
  background-color: var(--clima-2-soft) !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg3 .icon-dash {
  background-color: var(--clima-3-soft) !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg4 .icon-dash {
  background-color: var(--clima-4-soft) !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg5 .icon-dash {
  background-color: var(--clima-5-soft) !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg6 .icon-dash {
  background-color: var(--clima-6-soft) !important;
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.bg0 .icon-dash {
  background-color: rgba(65, 64, 64, 0.35);
  border-radius: 25%;
  margin: 3px !important;
  padding: 2px !important;
}

.border {
  border-collapse: collapse;
  border-radius: 6px;
  overflow: hidden;
}

.message {
  background-color: #fafafa;
}

.title-white {
  color: white !important;
  font-weight: 700 !important;
}

.heading {
  overflow: visible;
}

// En móvil la etiqueta y su gráfica se apilan; quitamos el padding entre
// ambas columnas para que la barra de distribución quede pegada a su variable
// (antes quedaba más cerca del siguiente bloque que de su propia etiqueta).
@media (max-width: 768px) {
  .columns.has-text-centered > .column.is-one-third {
    padding-bottom: 0 !important;
  }

  .columns.has-text-centered > .column:not(.is-one-third) {
    padding-top: 0 !important;
  }
}
</style>

<style lang="scss">
.contentTooltipInter {
  max-width: 20% !important;
  min-width: 10% !important;

  .tooltip-inner {
    background: rgba(0, 0, 0, 0.9);
  }
  .tooltip-arrow {
    border-color: rgba(0, 0, 0, 0.9);
  }
}

// En móvil el 20% del viewport deja el tooltip demasiado angosto; se ensancha.
@media (max-width: 768px) {
  .contentTooltipInter {
    max-width: 85vw !important;
    min-width: 70vw !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/graphDetailResult.vue